import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import { Card, Col, Input, Row, Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useDebounceValue } from "~/hooks/use-debounce";
import { ClientType } from "~/utils/constants";
import { useClientStore } from "./clients.store";

type Props = {};

export const FilterClients: FC<Props> = () => {
  const { filters, setFilters } = useClientStore();
  const [searchTerm, setSearchTerm] = useState(filters.search || "");

  const [search] = useDebounceValue(searchTerm, 500);

  useEffect(() => {
    setSearchTerm(filters.search || "");
  }, [filters.search]);

  useEffect(() => {
    setFilters({ search, page: 1 });
  }, [search, setFilters]);

  // Get all client types for the dropdown
  const clientTypes = Object.values(ClientType);

  return (
    <Card className="mb-6 shadow-sm">
      <Row gutter={16}>
        <Col xs={24} md={16}>
          <Input
            placeholder="Search clients by name, ID, or contact info..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            prefix={<SearchOutlined />}
            size="large"
          />
        </Col>

        <Col xs={24} md={8}>
          <div className="flex items-center gap-2">
            <FilterOutlined />
            <Select
              className="w-full"
              placeholder="Filter by client type"
              value={filters.type}
              onChange={(value) => setFilters({ type: value, page: 1 })}
              allowClear
              size="large"
              options={[
                { value: undefined, label: "All Types" },
                ...clientTypes.map((type) => ({
                  value: type,
                  label: type
                    .replace(/_/g, " ")
                    .toLowerCase()
                    .replace(/\b\w/g, (c) => c.toUpperCase()),
                })),
              ]}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};
